module.exports = __webpack_public_path__ + "static/img/iphone.8e53f7e7.png";